import { render, staticRenderFns } from "./ZoneWizardZoneTypeStep.vue?vue&type=template&id=7152e159&scoped=true&"
import script from "./ZoneWizardZoneTypeStep.vue?vue&type=script&lang=js&"
export * from "./ZoneWizardZoneTypeStep.vue?vue&type=script&lang=js&"
import style0 from "./ZoneWizardZoneTypeStep.vue?vue&type=style&index=0&id=7152e159&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7152e159",
  null
  
)

export default component.exports